var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-page"},[_c('block-header-standard',{attrs:{"title":_vm.title[_vm.locale]}}),_c('media-filters',{on:{"filtered":_vm.filtered}}),_c('media-list',{attrs:{"filterBy":_vm.filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }